import { z } from 'zod'

export const FolderSchema = z.object({
  type: z.string(),
  folder_id: z.number(),
  path: z.string(),
  title: z.string(),
  entity: z.number(),
  created: z.number(),
  modified: z.number(),
})
